import { render } from "./incomeWzz.vue?vue&type=template&id=847fd746&scoped=true"
import script from "./incomeWzz.vue?vue&type=script&lang=js"
export * from "./incomeWzz.vue?vue&type=script&lang=js"

import "./incomeWzz.vue?vue&type=style&index=0&id=847fd746&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-847fd746"]])

export default __exports__